<app-label-input [hasTooltip]="hasTooltip()" [required]="required()" [textTooltip]="textTooltip()"
   [textLabel]="textLabel()" />
@if(disabled()) {
<div class="d-flex align-items-start gap-10">
   <mat-form-field class="w-100" appearance="outline">
      <input matInput [value]="value() ? value() : ''" disabled />
   </mat-form-field>
</div>
} @else {
<div class="d-flex align-items-start gap-10">
   <mat-form-field class="w-100" appearance="outline">
      <input appOnlyNumber matInput [formControlName]="nameControl()!" placeholder="{{ placeholder() }}"
         [maxlength]="maxlength()" inputmode="numeric" [ngClass]="{'text-center' : isTextCenter()}" />
   </mat-form-field>
</div>
}